<template>
  <div class="row">
    <div class="col-12 mb-2">
      <div class="d-flex justify-content-between">
        <h4 class="text-primary" v-if="product !== 'aduanas'">
          Gestión de
          <span v-if="groupMood">usuarios</span>
          <span v-if="!groupMood">oficinas</span>
          <b-form-checkbox
            v-model="groupMood"
            name="check-button"
            switch
            class="ml-3"
            inline
            v-b-tooltip.hover.top="'Después de hacer click, espere'"
            data-cy="cambioDeGrupoAOficina"
          >
            <span class="switch-icon-left" data-cy="oficinas">
              <feather-icon icon="UsersIcon" />
            </span>
            <span class="switch-icon-right" data-cy="grupos">
              <feather-icon icon="AwardIcon" />
            </span>
          </b-form-checkbox>
        </h4>
        <h4 class="text-primary" v-if="product === 'aduanas'">
          Gestión de usuarios
        </h4>
        <b-button
          v-tooltip="'Descargar información de usuarios'"
          variant="primary"
          size="sm"
          data-cy="download-users-report"
          @click="downloadUsersReport(true)"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-3"
          />
          Descargar
        </b-button>
      </div>
    </div>
    <div class="groups col-4 bg-white shadow">
      <groups-tree
        :groupMood="groupMood"
        @select="onSelectedTreeItem"
      />
    </div>
    <div class="col-8 bg-white shadow">
      <b-tabs>
        <b-tab title="Detalles" v-if="selectedGroup.nombre !== company.razonSocial">
          <b-card-text>
            <div
              class="row mb-5"
              v-if="selectedGroup.nombre &&
              selectedGroup.nombre !== company.razonSocial"
            >
              <div class="col-md-6 mt-3">
                <vs-input
                  readonly="true"
                  class="w-100"
                  label="Código"
                  maxlength="40"
                  name="groupName"
                  v-model="selectedGroup.codigo"
                />
              </div>
              <div class="col-md-6 mt-3">
                <vs-input
                  readonly="true"
                  class="w-100"
                  label="Nombre de Grupo"
                  maxlength="250"
                  name="groupName"
                  v-model="selectedGroup.nombre"
                />
              </div>
              <div class="col-md-12 mt-3">
                <vs-input
                  readonly="true"
                  class="w-100"
                  label="Descripción de Grupo"
                  maxlength="250"
                  name="groupDescription"
                  v-model="selectedGroup.descripcion"
                />
              </div>
              <div class="col-md-12 mt-3" v-if="this.action !== 'addParent'">
                <div>
                  <vs-select
                    readonly="true"
                    class="w-100"
                    autocomplete
                    disabled
                    label="Es oficina"
                    name="isOffice"
                    v-model="selectedGroup.esOficina"
                  >
                    <vs-select-item
                      :value="'Y'"
                      text="Si"
                    />
                    <vs-select-item
                      :value="'N'"
                      text="No"
                    />
                  </vs-select>
                </div>
                <div class="row mt-3" v-if="selectedGroup.esOficina === 'Y'" style="cursor:none;">
                  <div class="col-md-4">
                    <label>Es tipo de oficina</label>
                  </div>
                  <div class="col-md-4">
                    <vs-radio
                      disabled
                      :vs-value="'int'"
                      v-model="selectedGroup.tipo"
                    >
                      Interna
                    </vs-radio>
                  </div>
                  <div class="col-md-4">
                    <vs-radio
                      disabled=""
                      vs-name="isPrivate"
                      :vs-value="'ext'"
                      v-model="selectedGroup.tipo"
                    >
                      Externa
                    </vs-radio>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-3" v-if="selectedGroup.entidadDocDigital">
                <vs-input
                  readonly="true"
                  class="w-100"
                  label="Código"
                  maxlength="40"
                  name="groupName"
                  v-model="selectedGroup.descripcionEntidadDocDigital"
                />
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab
          active
          title="Usuarios"
        >
          <b-card-text id="list-users">
            <user-table :users="usersTree" :group="selectedGroup" />
            <div class="mt-4 mb-4">
              <fb-paginacion
                :total="pagination.pages"
                :max="10"
                v-model="page"
              />
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal
      ref="getReportModal"
      hide-footer
      no-close-on-backdrop
      @hidden="resetModal"
      title="Descargar reporte de usuarios"
    >
      <b-overlay :show="loadingParameters">
        <strong>Seleccione los parámetros para el reporte</strong>
        <div class="mt-4 row justify-content-between">
          <div
            class="col-6"
            :key="option.key"
            v-for="(option) in optionsReport"
          >
            <b-form-group
              :label="`Categoría ${option.nombre}`"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                v-model="selected"
                :options="option.campos"
                :aria-describedby="ariaDescribedby"
                switches
                stacked
                value-field="key"
                text-field="nombre"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
        <div class="text-right">
          <b-button
            variant="primary"
            @click="downloadUsersReport(false)"
          >
            Enviar
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import GroupsTree from '@/febos/global/management/vistas/components/GroupsTree';
import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';
import UserTable from '@/febos/global/management/vistas/components/UserTable';
import { ioCompanyUsersReport, ioUsersReport } from '@/febos/servicios/api/v2.companies.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  name: 'UsersManagement',
  components: {
    GroupsTree,
    FbPaginacion,
    UserTable
  },
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO,
      page: 1,
      paginate: 10,
      action: '',
      usersTree: [],
      usersGeneral: [],
      groupMood: true,
      selectedGroup: {},
      loadingParameters: false,
      selected: [],
      optionsReport: []
    };
  },
  watch: {
    successAction() {
      if (this.successAction) {
        this.$bvToast.toast(
          `${this.successMessage}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        this.cleanSuccess();
      }
    },
    page(newValue) {
      if (this.loading) return;
      if (this.selectedGroup.nombre
        && this.selectedGroup.nombre !== this.company.razonSocial) {
        this.getUsersGroup({
          empresaId: this.company.id,
          pagina: newValue,
          filas: 20,
          groupId: this.selectedGroup.id
        });
      } else {
        this.getUsersCompany({
          empresaId: this.company.id,
          pagina: newValue,
          filas: 20,
          buscarInfoExtra: 'si',
          filtroInfoExtra: 'CARGO'
        });
      }
    },
    usersByGroup(newValue) {
      this.usersTree = newValue;
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#list-users > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#list-users',
        scale: 0.6
      });
    },
    usersCompany(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.usersTree = this.usersCompany;
      }
    },
    groupsCompany(newVal) {
      this.selectedGroup = (newVal || []).find((group) => group.id === this.selectedGroup.id) || {};
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany',
      'pagination',
      'usersByGroup',
      'loading',
      'groupsCompany'
    ]),
    ...mapGetters('Usuario', [
      'successMessage',
      'successAction'
    ]),
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getUsersGroup'
    ]),
    ...mapActions('Usuario', [
      'cleanSuccess'
    ]),
    onSelectedTreeItem(selectedGroup) {
      this.selectedGroup = selectedGroup;
      this.page = 1;
    },
    resetModal() {
      this.selected = [];
      this.optionsReport = [];
    },
    async downloadUsersReport(simulate) {
      if (this.isAguasAndinas) {
        this.$vs.notify({
          title: 'Danos unos segundos!',
          text: 'Estamos buscando la información',
          color: 'success',
          time: 4000,
          position: 'top-center'
        });
        const { data } = await ioCompanyUsersReport({
          empresaId: this.company.id
        });
        window.open(data.url, '_blank');
      } else {
        if (!simulate && !this.selected.length) {
          this.$vs.notify({
            title: 'Error',
            text: 'Por favor, ingresa algún parámetro para el reporte',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: ALERT_POSITION
          });
          return;
        }
        this.$refs.getReportModal.show();
        this.loadingParameters = true;
        const { data } = await ioUsersReport({
          empresaId: this.company.id,
          simular: simulate ? 'si' : 'no',
          body: {
            ...((!simulate && !!this.selected.length) && { campos: this.selected })
          }
        });

        if (simulate) {
          this.optionsReport = data.esquema;
        } else {
          window.open(data.url, '_blank');
          this.$refs.getReportModal.hide();
        }
        this.loadingParameters = false;
      }
    }
  },
  async created() {
    await this.getUsersCompany({
      empresaId: this.company.id,
      pagina: 1,
      filas: 20,
      buscarInfoExtra: 'si',
      filtroInfoExtra: 'CARGO'
    });
    this.cleanSuccess();
  }
};
</script>

<style scoped>
.item {
  cursor: pointer;
  list-style: none;
}
.wrap-table {
  max-height: 600px;
  overflow-y: auto;
}
.groups {
  height: 750px;
  overflow-y: auto;
}
</style>
